export default "__VITE_ASSET__DJoue6U2__ 584w";